module.exports = __webpack_public_path__ + "static/media/mhra-uk.f9656a67.png";